import { render, staticRenderFns } from "./PrintCommonStockTransfer.vue?vue&type=template&id=1bc26bdc&"
import script from "./PrintCommonStockTransfer.vue?vue&type=script&lang=js&"
export * from "./PrintCommonStockTransfer.vue?vue&type=script&lang=js&"
import style0 from "./PrintCommonStockTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VDataTable,VRow})
